import {
    openDefaultEditor,
    createDefaultImageWriter,
    getEditorDefaults,
} from '@pqina/pintura/pintura';

export default Alpine.data('animalImageEditor', (livewireInstance) => ({
    init() {
        console.log('Animal Image Editor initialized');
    },
    openEditor(mediaUrl) {
        const options = getEditorDefaults({
            imageWriter: createDefaultImageWriter({
                targetSize: {
                    width: 1028,
                    height: 1028,
                    fit: 'cover',
                },
            }),
            imageCropAspectRatio: 1,
        });

        // Find the parent modal to attach Pintura modal to it
        const parentModal = this.$el.closest('[x-ref="modal"]');

        const editorConfig = {src: mediaUrl, ...options};

        // Use the second parameter to set parent element for the modal
        const editor = parentModal
            ? openDefaultEditor(editorConfig, parentModal)
            : openDefaultEditor(editorConfig);

        editor.on('process', (output) => {
            const editedImage = output.dest;
            livewireInstance.upload('file', editedImage);
        });
    },
}))
